/**
 * A line that opens under a bubble without a jump (Gabriel 2026-10-06: a send's failure line):
 * it grows from no height and fades in, so a thread pinned to its newest entry follows it frame
 * by frame instead of moving at once. Shared by the admin and client chat threads; each skin
 * styles the line itself and places the wrap with `className` (alignment, the margin under the bubble).
 */
import type { ReactNode } from 'react';
import styles from './RevealLine.module.css';

export function RevealLine({ className, children }: { className?: string; children: ReactNode }) {
  return (
    <div className={className ? `${styles.reveal} ${className}` : styles.reveal}>
      <div className={styles.clip}>{children}</div>
    </div>
  );
}
